import React from 'react';
import PropTypes from 'prop-types';
import { TooltipHost, DirectionalHint, TooltipOverflowMode } from 'office-ui-fabric-react';
import styles from './TextOverflow.style';

const TextOverflow = ({ itemId, content, directionalHint }) => {
  return (
    <div className={styles.overflowContainer}>
      <TooltipHost
        overflowMode={TooltipOverflowMode.Parent}
        content={content}
        id={itemId}
        directionalHint={directionalHint}
        calloutProps={styles.callout}
        tooltipProps={styles.tooltip}
      >
        <span aria-describedby={itemId}>{content}</span>
      </TooltipHost>
    </div>
  );
};

TextOverflow.propTypes = {
  itemId: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  directionalHint: PropTypes.number,
};

TextOverflow.defaultProps = {
  content: '',
  directionalHint: DirectionalHint.topCenter,
};

export default TextOverflow;
